<template>
  <div class="clientContentWrap">
    <h4 class="subTitle">의뢰 내용</h4>
    <div class="clientContent">
      <textarea ref="content"
                @input="updateContent">{{this.content_}}</textarea>

    </div>
  </div>
</template>

<script>
  import { mapGetters , mapState , mapActions , mapMutations } from 'vuex'

  export default {
    name: "client-content",
    components: {},
    props: [],
    computed: {
      ...mapState('contactUsStore' , ['content'])
    },
    watch: {
      content (value) {
        if(value === null){
          this.resetContent();
        }

      },
    },
    methods: {
      ...mapMutations('contactUsStore' , ['SET__CONTENT']) ,
      updateContent (e) {
        if(e.target.value !== this.$store.state['contactUsStore'].content)
          this.SET__CONTENT(e.target.value);
      },
      resetContent () {
        this.$refs.content.value = '';
      },
    },
    data() {
      return {
        content_ : '',
      }
    },
    created() {

    },
    beforeUpdate () {
      //console.log('beforeUpdate');
    },
    updated() {
      //console.log('updated');
    },
    mounted() {
     // console.log('mounted');
    },


  }
</script>

<style scoped lang="scss">
  @import "@/styles/ContactUs.scss";
  .clientContentWrap{
    width:45%;
    .clientContent{
      height:75%;
      >textarea {
        width:100%;
        height:100%;
        border:1px solid #cccccc;
        min-width: 100%;
        max-width: 100%;
        min-height: 100%;
        max-height: 100%;
        font-size:1.2rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/ContactUs/ClientContent.vue